import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eventbrite/i18n';
import { formValidate } from '@eventbrite/eds-utils';
import { CLEAR_LABEL } from '../../constants';
import {
    INPUT_LABEL,
    INPUT_PLACEHOLDER,
    PROMO_CODE_FORM_PROP_TYPE,
    FORM_STATUS,
    REDUX_FORM_PROP_TYPES,
} from './constants';
import { PromoCodeInputField } from './PromoCodeInputField';
import {
    getCtaText,
    getExternalCta,
    getInternalCta,
    getPromoCodeSuccessMessageText,
    getStatus,
} from './utils';

class PromoCodeForm extends React.PureComponent {
    static propTypes = {
        ...REDUX_FORM_PROP_TYPES,
        ...PROMO_CODE_FORM_PROP_TYPE,
        /**
         * The page rendering the PromoCodeForm; used for tracking
         */
        checkoutStep: PropTypes.string,
        /**
         * Text to display as the form label
         */
        inputLabel: translationPropType,
        /**
         * True if the event is a registration one
         */
        isRegEvent: PropTypes.bool,
        /**
         * Number of tickets with promo code applied
         */
        numPromoCodeTickets: PropTypes.number,
    };

    static defaultProps = {
        inputLabel: INPUT_LABEL,
    };

    state = {
        query: '',
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const status = getStatus(nextProps);
        const { promoCode: query } = nextProps.options;

        if (status === FORM_STATUS.SUCCESS) {
            this.setState({ query });
        }
    }

    handleClear = () => {
        const { onClear } = this.props.handlers;
        const checkoutStep = this.props.checkoutStep;
        const promoCode = this.state.query;

        this.setState({ query: '' });

        onClear(promoCode, CLEAR_LABEL, checkoutStep);
    };

    handleChange = (query) => {
        const { onChange } = this.props.handlers;

        this.setState({ query });

        onChange();
    };

    getClickHandlers = () => ({
        [FORM_STATUS.EMPTY]: null,
        [FORM_STATUS.SUCCESS]: this.props.handlers.onRemove || this.handleClear,
        [FORM_STATUS.FAILURE]: this.handleClear,
        [FORM_STATUS.DEFAULT]: this.props.handleSubmit,
    });

    render() {
        const {
            handleSubmit,
            inputLabel,
            submitFailed,
            options,
            numPromoCodeTickets,
            isRegEvent,
        } = this.props;
        const {
            amountOff,
            isLoading,
            percentOff,
            promoCode,
            promoCodeType,
            shouldShowExternalCta,
        } = options;

        const clickHandlers = this.getClickHandlers();
        const status = getStatus(this.props);
        const isCodeSuccessful = status === FORM_STATUS.SUCCESS;
        const isFieldEmpty = status === FORM_STATUS.EMPTY;

        const internalCta = getInternalCta({
            ctaText: getCtaText(status).toString(),
            isDisabled: isFieldEmpty,
            isLoading,
            isSubmitFailed: status === FORM_STATUS.FAILURE,
            onClick: clickHandlers[status],
        });

        const externalCta = getExternalCta({
            isDisabled: isFieldEmpty,
            onClick: handleSubmit,
            shouldShowExternalCta,
        });

        const promoCodeSuccessMessage = isCodeSuccessful
            ? getPromoCodeSuccessMessageText({
                  promoCode,
                  promoCodeType,
                  percentOff,
                  amountOff,
                  numPromoCodeTickets,
                  isRegEvent,
              })
            : null;

        return (
            <div>
                <PromoCodeInputField
                    cta={internalCta}
                    handleSubmit={handleSubmit}
                    helperText={promoCodeSuccessMessage}
                    inputLabel={inputLabel}
                    inputPlaceholder={INPUT_PLACEHOLDER}
                    isCodeSuccessful={isCodeSuccessful}
                    onChange={this.handleChange}
                    submitFailed={submitFailed}
                />
                {externalCta}
            </div>
        );
    }
}

export default formValidate({
    touchOnBlur: false,
})(PromoCodeForm);
